<script>

import { resourceHeaders } from '@/modules/authorization/config';

import ContentResource from './ContentResource';
import AdminResource from './AdminResource';
import BoardResource from './BoardResource';
import SitesResource from './SitesResource';
import TaxonomyResource from './TaxonomyResource';
import WorkflowResource from './WorkflowResource';
import ToolsResource from './ToolsResource';

function resourceComponent(resource) {
  switch (resource) {
    case 'boards':
      return BoardResource;
    case 'contents':
      return ContentResource;
    case 'taxonomies':
      return TaxonomyResource;
    case 'workflow':
      return WorkflowResource;
    case 'tools':
      return ToolsResource;
    case 'admin':
      return AdminResource;
    case 'sites':
      return SitesResource;
    default:
      return 'td';
  }
}

export default {
  functional: true,
  name: 'nx-resource-row-table',
  props: {
    resource: {
      type: String,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  render(createElement, { props }) {
    const resource = props.resource;
    const columns = resourceHeaders[resource];
    const component = resourceComponent(resource);
    return columns.map(headerName => createElement(component, { props, headerName }));
  },
};
</script>
